<button #menuTrigger="matMenuTrigger"
[matMenuTriggerFor]="dropDown" 
[class.btn]="appearance !== 'mat-menu-item'"
[class.btn-blue]="appearance !== 'mat-menu-item'"
[class.mat-menu-item]="appearance === 'mat-menu-item'"
[class.mat-focus-indicator]="appearance === 'mat-menu-item'"
fxLayout="row" 
(click)="$event.stopPropagation()"
fxLayoutAlign="center center"> 
    <ng-content></ng-content>
</button>

<mat-menu class="client-create-menu" #dropDown="matMenu">
    <div class="card-filter" id="card-filter" (click)="$event.stopPropagation()">

        <div class="card-client-create-header form-menu-header">
            <div class="card-client-create-header-title form-menu-header-title">
                {{ tag ? 'Editar Tag' : 'Adicionar Tag' }}

                <div class="form-menu-close-btn">
                    <button mat-icon-button (click)="close()">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
            </div>
        </div>

        <div class="card-client-create-content form-menu-content">
            <app-form-tag-create-or-edit 
                [tag]="tag"
                [manuTrigger]="menuTrigger"
                (onCreatedTag)="created($event)"
                (onUpdatedTag)="updated($event)">
            </app-form-tag-create-or-edit>
        </div>

    </div>
</mat-menu>